import type { Image } from '$models/Image/Image';

export function getWordPressImageSrcSet(
	image: Pick<Image, 'url' | 'width' | 'sizes'> | null | undefined
): string | undefined {
	if (!image) {
		return undefined;
	}

	const originalWidth = Number(image.width);
	const variants = [
		image.sizes?.thumbnail ? `${image.sizes.thumbnail} 150w` : null,
		image.sizes?.medium ? `${image.sizes.medium} 300w` : null,
		image.sizes?.medium_large ? `${image.sizes.medium_large} 768w` : null,
		image.sizes?.large ? `${image.sizes.large} 1024w` : null,
		image.url && Number.isFinite(originalWidth) && originalWidth > 0
			? `${image.url} ${originalWidth}w`
			: null
	].filter((variant): variant is string => Boolean(variant));

	return variants.length > 0 ? [...new Set(variants)].join(', ') : undefined;
}
